<template>
    <v-container fluid color="grey lighten-3">
        <v-layout wrap justify-center align-center mt-4>
            <v-flex xs12 text-center mb-2>
                <img height="39"  src="@/assets/img/logo.png" />
            </v-flex>
            <v-flex xs12 md8 lg6 class="text-center">
                <v-img :src="require('@/assets/img/base/404.jpg')" aspect-ratio="1.7" cover></v-img>
                <h1 class="headline mb-1  mt-2">Nooo...!, Lo sentimos</h1>
                <v-divider></v-divider>
                <h2 class="title font-weight-light mt-2">
                    El recurso que buscas no existe
                    <v-icon  color="accent lighten-2">far fa-frown</v-icon>
                </h2>

            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    export default{

    }
</script>
